import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/app/(pages)/privacy-policy/page.tsx");
